import React from 'react';

const AccordionArrowIcon = (props) => {
  const {
          isOpen,
          fill,
        } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          isOpen
            ? 'M10.5893 13.0893C10.2638 13.4147 9.73618 13.4147 9.41074 13.0893L5.24408 8.9226C4.91864 8.59716 4.91864 8.06952 5.24408 7.74409C5.56951 7.41865 6.09715 7.41865 6.42259 7.74409L10 11.3215L13.5774 7.74409C13.9028 7.41865 14.4305 7.41865 14.7559 7.74409C15.0814 8.06952 15.0814 8.59716 14.7559 8.9226L10.5893 13.0893Z'
            : 'M9.41074 6.91074C9.73618 6.5853 10.2638 6.5853 10.5893 6.91074L14.7559 11.0774C15.0814 11.4028 15.0814 11.9305 14.7559 12.2559C14.4305 12.5814 13.9028 12.5814 13.5774 12.2559L10 8.67854L6.42259 12.2559C6.09715 12.5814 5.56951 12.5814 5.24408 12.2559C4.91864 11.9305 4.91864 11.4028 5.24408 11.0774L9.41074 6.91074Z'
        }
        fill={fill || '#64748b'}
      />
    </svg>
  );
};

export default AccordionArrowIcon;